import { Component, OnInit, Inject } from '@angular/core';
import { AdminService } from '../admin.service';
import { Content, Disclaimer } from '../../shared/models/content';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import * as _ from 'lodash';
import { TCCPLocalStorageService } from '../../shared/services/tccp-local-storage.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-manage-disclaimer',
  templateUrl: './manage-disclaimer.component.html',
  styleUrls: ['./manage-disclaimer.component.scss']
})
export class ManageDisclaimerComponent implements OnInit {
  public disclaimers: Content[];
  public content: Content = < Content > {};
  public alerts: any[] = [];
  public hasPermission = false ;
  public hasDeletePermission = false ;

  constructor(
    private adminService: AdminService, public commonService: TCCPCommonService,
    private storageService: TCCPLocalStorageService, private dialog: MatDialog) { }

  ngOnInit() {
    this.getAllDisclaimers();
    const roles: string[] = this.storageService.getRoles();
    const userAccess = this.commonService.getAccess('Disclaimer', roles);
    const accessLevel = _.get(userAccess[0], 'accessLevel');
    if (accessLevel === 1 || accessLevel === 3) {
      this.hasPermission = true;
    }
  }

  getAllDisclaimers() {
    this.adminService.getAllDisclaimers().subscribe((response: any) => {
      if (response) {
        this.disclaimers = response.sort((obj1, obj2) => {
          return obj1.disclaimer.disclaimerId - obj2.disclaimer.disclaimerId;
        });
      }
    });
  }

  addDisclaimer() {
    const dialogRef = this.dialog.open(AddDisclaimerDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const contentObj: Content = < Content > {
          contentId: null, contentType: 'disclaimer',
          division: this.adminService.selectedApplication,
          disclaimer: result.data
        };
        this.content = contentObj;
        let id = 0;
        if (this.disclaimers.length === 0) {
          id = 1;
        } else {
          id = this.disclaimers[this.disclaimers.length - 1].disclaimer.disclaimerId + 1;
        }
        this.content.disclaimer.disclaimerId = id;
        this.adminService.insertdocument(this.content).subscribe((response: any) => {
          if (response) {
            this.getAllDisclaimers();
            this.showAlertMessages('success', this.content.disclaimer.disclaimerTitle + ' is added successfully');
          }
        });
      }
    });
  }

  editDisclaimer(content: Content) {
    const dialogRef = this.dialog.open(AddDisclaimerDialogComponent, {
      width: '500px',
      data: content.disclaimer
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        content.disclaimer = result.data;
        this.adminService.updateSupportContent(content).subscribe((response: any) => {
          if (response) {
            this.getAllDisclaimers();
            this.showAlertMessages('success', content.disclaimer.disclaimerTitle + ' is updated successfully');
          }
        });
      }
    });
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

}

@Component({
  selector: 'app-add-disclaimer-dialog-component',
  templateUrl: './add-disclaimer-dialog.component.html',
  styleUrls: ['../admin.component.scss', './manage-disclaimer.component.scss']

})
export class AddDisclaimerDialogComponent implements OnInit {
  public disclaimer: Disclaimer = < Disclaimer > ({
    disclaimerMessage: null, disclaimerTitle: null
  });
  public alerts: any[] = [];
  public theme: string = null;

  constructor(
    public dialogRef: MatDialogRef<ManageDisclaimerComponent>, private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }


  ngOnInit() {
    this.theme = environment.applicationName + '-' + this.adminService.selectedApplication;
    if (this.data) {
      this.disclaimer = this.data;
    }
  }
  close(): void {
    this.dialogRef.close();
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  onSelect() {
    if (this.disclaimer.disclaimerTitle && this.disclaimer.disclaimerMessage) {
      this.dialogRef.close({ event: 'save', data: this.disclaimer });
    } else {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.DISCLAIMER_MANDATORY_MESSAGE);
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
